import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-200" }
const _hoisted_2 = { class: "md:max-w-7xl mx-auto" }

import Loader from "./components/Loader.vue";
import NavBar from "./components/layout/NavBar.vue";
import { branding } from "./branding";
import store from "./store";
import { onMounted, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const logado = computed(() => store.state.auth_token != "");

const updateTitle = () => {
  document.title = branding.pageTitle;
};

onMounted(() => {
  updateTitle();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Loader),
    (_unref(logado))
      ? (_openBlock(), _createBlock(NavBar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full", _unref(logado) ? 'p-2' : ''])
      }, [
        _createVNode(_component_router_view)
      ], 2)
    ])
  ]))
}
}

})